import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  getRefundInput,
  getRefundSalePurchaseInput,
  getRefundSalesInput,
  getRefundsInput,
  RefundLiteModel,
  RefundModel,
  RefundSalePurchaseLiteModel,
} from './model';

export function useGetRefunds(
  input?: getRefundsInput,
  options?: UseQueryOptions<ExtendedApiResult<RefundLiteModel[]>, ApiError>,
): UseQueryResult<ExtendedApiResult<RefundLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['get-refunds', input?.params],
      () =>
        QueryFetchFunction({
          url: 'refunds',
          params: input?.params,
        }),
      options,
    ),
    RefundLiteModel,
  );
}

export function useGetRefund(
  input?: getRefundInput,
  options?: UseQueryOptions<ApiResult<RefundModel>, ApiError>,
): UseQueryResult<ApiResult<RefundModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['get-refunds', input?.id],
      () =>
        QueryFetchFunction({
          url: `refunds/${input?.id}`,
        }),
      options,
    ),
    RefundModel,
  );
}

export function useGetRefundPurchase(
  input?: getRefundSalePurchaseInput,
  options?: UseQueryOptions<
    ExtendedApiResult<RefundSalePurchaseLiteModel[]>,
    ApiError
  >,
): UseQueryResult<ExtendedApiResult<RefundSalePurchaseLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['get-refund-sale-purchases', input],
      () =>
        QueryFetchFunction({
          url: `sales/${input?.id}/get-refund-sale-purchases`,
          params: input?.params,
        }),
      options,
    ),
    RefundSalePurchaseLiteModel,
  );
}

export function getRefundsKey(input?: getRefundsInput) {
  return ['get-refunds', input?.params];
}

export function getRefundKey(input?: getRefundInput) {
  return ['get-refunds', input?.id];
}

export function getRefundSalesKey(input?: getRefundSalesInput) {
  return ['get-refunds-sales', input?.params];
}

export function getRefundPurchaseKey(input?: getRefundSalePurchaseInput) {
  return ['get-refund-sale-purchases', input];
}
